// extracted by mini-css-extract-plugin
module.exports = {"readMoreHeading":"UpperContent_readMoreHeading__N4uUe","active":"UpperContent_active__K4VW_"};